<template>
    <div class="h-layout h-layout-full-height h-layout-blank">
        <div class="h-layout-content">
            <main class="h-o-main-content">
                <div class="container-lg">
                    <router-view />
                </div>
            </main>
        </div>

        <global-alert disable-notification />
    </div>
</template>

<script>
    import GlobalAlert from '@/components/molecules/GlobalAlert'

    export default {
        components: {
            GlobalAlert,
        }
    }
</script>

<style lang="stylus">
    .h-layout-blank {
        background-color: #F8F8F8
    }
</style>